import styled from 'styled-components'

export const Container = styled.div`
  font-size: ${props => props.theme.texts.bodyMRegular.fontSize};
  font-family: ${props => props.theme.texts.bodyMRegular.fontFamily};
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.spacing.sp8};
`
